import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import clsx from 'clsx';
import React from 'react';

import classes from './Error.module.scss';

interface ErrorProps {
    title: string;
    icon?: IconProp;
    className?: string;
}

export const Error: React.FC<ErrorProps> = props => {
    return (
        <div className={clsx(classes.root, props.className)}>
            {props.icon && <FontAwesomeIcon icon={props.icon} />}

            {props.title}
        </div>
    );
};
